// extracted by mini-css-extract-plugin
module.exports = {"root":"TagStreamHeader__root--3Mlyt"};